<template lang="pug">
.h-vertical-align-container(v-if='notifyPastDueModal')
  .modal__overlay
  .modal__wrapper.modal__wrapper--marketingConsent
      .modal__marketingconsent
          h1 Account Past Due
          .marketingConsent--container
              p Your billing information needs to be updated to reenable your plan.
          a(:href="merchantURL")
              button.btn.btn--purpleLight Update
          button.btn.btn--white(@click="closeModal()") Later
</template>

<script>
import Eventbus from '../eventBus.js';

export default {
  name: 'NotifyPastDue',
  data() {
    return {
      notifyPastDueModal: false,
      merchantURL: '',
      account: '',
    };
  },
  mounted() {
    this.account = JSON.parse(localStorage.getItem('account'));
    const self = this;
    if (this.account !== null) {
      this.merchantURL = this.account.subscription.merchant_billing_url;
      if (this.account.subscription.past_due) {
        if (this.$cookies.get('notifyPastDueIgnored')) {
          this.notifyPastDueModal = false;
        } else {
          this.notifyPastDueModal = true;
        }
      }
    }
    Eventbus.$on('triggerNotifyModal', function (data) {
      if (data) {
        self.notifyPastDueModal = true;
      } else {
        self.notifyPastDueModal = false;
      }
    });
  },
  methods: {
    closeModal() {
      this.notifyPastDueModal = false;
      this.$cookies.set('notifyPastDueIgnored', true, { expires: 1 });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/NotifyPastDue.vue